class CustomSelectLanguage extends CustomSelect
{
  init() {
    super.init();

    this.addEventListener('change', e => {
      this.closest('form').submit();
    });
  }

  wrap ()
  {
    super.wrap();

    this.wrapperDiv.classList.add('custom-select--language');
  }

  update ()
  {
    this.optionsDiv.querySelectorAll('[data-option-index]').forEach(option => option.classList.remove('selected'));

    const index = this.optionIndex || this.selectElement.options.selectedIndex;
    const originalOption = this.selectElement.options[index];
    const option = this.optionsDiv.querySelector(`[data-option-index="${index}"]`);

    if (option) {
      option.classList.add('selected');

      const div = document.createElement('div');
      div.classList.add('custom-select__language');
      div.innerHTML = `
        <div class="custom-select__language--icon">
          <img src="${originalOption.dataset.icon}" />
        </div>
        <div class="custom-select__language--box">
          <div class="custom-select__language--label">${this.dataset.stringLanguage}</div>
          <div class="custom-select__language--value">${option.innerHTML}</div>
        </div>
      `;

      this.valueDiv.innerHTML = '';
      this.valueDiv.appendChild(div);
    } else {
      this.valueDiv.innerHTML = '';
    }
  }
}

if (!customElements.get('custom-select-language')) {
  customElements.define('custom-select-language', CustomSelectLanguage);
}